import type { SVGProps } from 'react'

export const BellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    viewBox="0 0 16 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 13.5C0 13.6547 0.0321429 13.8129 0.1 13.9605C0.285714 14.3648 0.692857 14.625 1.14286 14.625H14.8571C15.3071 14.625 15.7143 14.3648 15.9 13.9605C15.9679 13.8129 16 13.6547 16 13.5C16 13.2293 15.9 12.9621 15.7107 12.7512L15.4464 12.4594C14.3321 11.2219 13.7143 9.6293 13.7143 7.97344V7.3125C13.7143 4.59141 11.75 2.32031 9.14286 1.8V1.125C9.14286 0.502734 8.63214 0 8 0C7.36786 0 6.85714 0.502734 6.85714 1.125V1.8C4.25 2.32031 2.28571 4.59141 2.28571 7.3125V7.97344C2.28571 9.62578 1.66786 11.2219 0.553571 12.4594L0.289286 12.7512C0.1 12.9621 0 13.2293 0 13.5Z"
      fill="currentColor"
    />
    <path
      d="M10.2857 15.75C10.2857 16.3477 10.0464 16.9207 9.6178 17.3426C9.18923 17.7645 8.60709 18 7.99995 18C7.3928 18 6.81066 17.7645 6.38209 17.3426C5.95352 16.9207 5.71423 16.3477 5.71423 15.75H7.99995H10.2857Z"
      fill="currentColor"
    />
  </svg>
)
